import React, {CSSProperties} from 'react';

type Props = {
    colour: CSSProperties['color']
    filter?: CSSProperties['filter']
}

function Dot({colour, filter}: Props) {
    return (
        <svg
            className="h-2 w-2"
            fill="currentColor"
            viewBox="0 0 8 8"
            style={{color: colour, filter}}
        >
            <circle cx={4} cy={4} r={3} />
        </svg>
    );
}

export default Dot;